import type { AnySchema, NumberSchema, Schema, StringSchema } from 'yup';
import * as yup from 'yup';

export abstract class Field {
  public static fieldName: string;
  public static validator: AnySchema;
}

export abstract class StringField implements Field {
  public static fieldName: string;
  public static validator: StringSchema = yup.string().trim().required();
}

export abstract class OptionalStringField implements Field {
  public static fieldName: string;
  public static validator: Schema = yup
    .string()
    .trim()
    .nullable()
    .transform((value) => value || null);
}

export abstract class EmailField implements Field {
  public static fieldName: string;
  public static validator: StringSchema = yup
    .string()
    .trim()
    .email()
    .required();
}

export abstract class OptionalEmailField implements Field {
  public static fieldName: string;
  public static validator: Schema = yup
    .string()
    .trim()
    .email()
    .nullable()
    .transform((value) => value || null);
}

export abstract class DateField implements Field {
  public static fieldName: string;
  public static validator = yup
    .date()
    .nullable()
    .transform((curr, orig) => (orig === '' ? null : curr))
    .required();
}

export abstract class DropdownField implements Field {
  public static fieldName: string;
  public static options: readonly string[];
  public static validator: Schema;
}

export abstract class BooleanField implements Field {
  public static fieldName: string;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .required();
}

export abstract class OptionalBooleanField implements Field {
  public static fieldName: string;
  public static validator = yup
    .boolean()
    .transform((value) => (value === '' ? undefined : value))
    .optional();
}

export abstract class PositiveIntegerField implements Field {
  public static fieldName: string;
  public static validator: NumberSchema = yup
    .number()
    .typeError('isNumber')
    .positive()
    .integer()
    .required();
}

export abstract class PositiveFloatField implements Field {
  public static fieldName: string;
  public static validator: NumberSchema = yup
    .number()
    .typeError('isNumber')
    .positive()
    .required();
}

export abstract class ZeroOrPositiveFloatField implements Field {
  public static fieldName: string;
  public static validator: NumberSchema = yup
    .number()
    .typeError('isNumber')
    .min(0)
    .required();
}

export abstract class MultipleValuesField implements Field {
  public static fieldName: string;
  public static options: readonly string[];
  public static validator = yup.array();
}
